var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"content"}},[_c('PageTitle',{attrs:{"title":"Eurofiscalis"}}),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-content animated fadeInRight"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('ListCompanies'),_vm._v(" "),_c('ListRequests')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }